import { firebase } from '@firebase/app'
import '@firebase/firestore'
import '@firebase/storage'

const firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyDt3mCCRiA7VjSDMWBRwUrUciHPmsttPJ8',
  authDomain: 'read-thai-199413.firebaseapp.com',
  projectId: 'read-thai-199413',
  storageBucket: 'read-thai-199413.appspot.com',
  messagingSenderId: '331122854808'
})

const db = firebaseApp.firestore()
const storage = firebaseApp.storage().ref()

if (process.env.NODE_ENV !== 'production') {
  db.enablePersistence({ experimentalTabSynchronization: true })
    .then(() => {
      console.log('Woohoo! Multi-Tab Persistence!')
    })
}

// Initialize Cloud Firestore through Firebase
export { db, storage }
